import { useEffect } from 'react'
import { useAnalyticsView } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'
import { Card, CardColors, Link, List, Text } from '@/ui'

export const SupportCenterCard = () => {
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('viewed support center card')
  }, [pageView])

  return (
    <Card color={CardColors.LEVEL_0}>
      <Text variant={TypographyStyles.H2}>Support Center</Text>

      <Text>
        If you have questions about your practice&apos;s finances or how to use
        Heard, message us via{' '}
        <Link
          href="/conversations"
          trackMessage="Clicked message us on support center card"
          trackAttributes={{ button: 'message us' }}
        >
          Messages
        </Link>
        .
      </Text>

      <List>
        <List.Item>
          <Link
            href="https://support.joinheard.com/hc/en-us/categories/360006112673-Frequently-Asked-Questions"
            newPage
            trackMessage="Clicked faqs on support center card"
            trackAttributes={{ button: 'FAQs' }}
          >
            FAQs
          </Link>
        </List.Item>

        <List.Item>
          <Link
            href="https://support.joinheard.com/hc/en-us/categories/1500000154101-Bookkeeping-and-Tax-Resources"
            newPage
            trackMessage="Clicked bookkeeping and tax resources on support center card"
            trackAttributes={{ button: 'Bookkeeping and Tax Resources' }}
          >
            Bookkeeping and Tax Resources
          </Link>
        </List.Item>

        <List.Item>
          <Link
            href="https://www.joinheard.com/resources"
            newPage
            trackMessage="Clicked resource hub on support center card"
            trackAttributes={{ button: 'Resource Hub' }}
          >
            Resource Hub
          </Link>
        </List.Item>
      </List>
    </Card>
  )
}
